import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from 'vue-router';
import store from '@/store';
import helper from '@/core/helper.js';
import i18n from '@/core/plugins/i18n';
import { Mutations, Actions } from '@/store/enums/StoreEnums';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/home',
    component: () => import('@/components/page-layouts/MainAuth.vue'),
    children: [
      {
        path: '/home',
        name: 'dashboard',
        meta: {
          isGuest: true,
        },
        component: () => import('@/views/Home.vue'),
      },
      {
        path: '/events',
        name: 'events',
        meta: {
          isGuest: true,
        },
        component: () => import('@/views/events/Events.vue'),
      },
      {
        path: '/events/:id',
        name: 'show_events',
        meta: {
          isGuest: true,
        },
        component: () => import('@/views/events/ShowEvent.vue'),
      },
      {
        path: '/news',
        name: 'news',
        meta: {
          isGuest: true,
        },
        component: () => import('@/views/news/News.vue'),
      },
      {
        path: '/news/:id',
        name: 'show_news',
        meta: {
          isGuest: true,
        },
        component: () => import('@/views/news/ShowNews.vue'),
      },
      {
        path: '/auth',
        name: 'login_page',
        meta: {
          isGuest: true,
        },
        component: () => import('@/views/authentication/basic-flow/SignUp.vue'),
      },
      {
        path: '/forget_password',
        name: 'forget_password',
        meta: {
          isGuest: true,
        },
        component: () => import('@/views/authentication/basic-flow/ForgetPassword.vue'),
      },
      {
        path: '/reset_password/:token',
        name: 'reset_password',
        meta: {
          isGuest: true,
        },
        component: () => import('@/views/authentication/basic-flow/ResetPassword.vue'),
      },
      {
        path: '/complete_register/:token',
        name: 'complete_register_page',
        meta: {
          isGuest: true,
        },
        component: () => import('@/views/authentication/basic-flow/CompleteSignUp.vue'),
      },
      // {
      //     path: "/auth",
      //     name: "register_page",
      //     meta: {
      //         isGuest: true
      //     },
      //     component: () => import("@/views/authentication/basic-flow/SignUp.vue"),
      // },
      // {
      //     path: "/otp-verification",
      //     name: "otp_verification_page",
      //     meta: {
      //         isGuest: true
      //     },
      //     component: () => import("@/views/authentication/basic-flow/SignInOTP.vue"),
      // },
    ],
  },
  {
    path: '/',
    component: () => import('@/components/page-layouts/Main.vue'),
    children: [
      {
        path: '/profile',
        name: 'profile_page',
        meta: {
          isGuest: false,
        },
        component: () => import('@/views/authentication/basic-flow/Profile.vue'),
      },
      {
        path: '/all-programs',
        name: 'all_programs_page',
        meta: {
          isGuest: false,
        },
        component: () => import('@/views/programs/AllPrograms.vue'),
      },
      {
        path: '/all-programs/apply_program/:id',
        name: 'apply_program_page',
        meta: {
          isGuest: false,
        },
        component: () => import('@/views/programs/ApplyProgram.vue'),
      },
      {
        path: '/all-programs/success_program/:id',
        name: 'success_program_page',
        meta: {
          isGuest: false,
        },
        component: () => import('@/views/programs/SuccessApplyProgram.vue'),
      },
      {
        path: '/all-programs/show_program/:id',
        name: 'show_program_page',
        meta: {
          isGuest: false,
        },
        component: () => import('@/views/programs/ShowProgram.vue'),
      },
      // {
      //     path: "/all-programs/re_apply/:id",
      //     name: "re_apply_program_page",
      //     meta: {
      //         isGuest: false
      //     },
      //     component: () => import("@/views/programs/Re_ApplyProgram.vue"),
      // },
      {
        path: '/my-programs',
        name: 'my_programs_page',
        meta: {
          isGuest: false,
        },
        component: () => import('@/views/programs/MyPrograms.vue'),
      },
      {
        path: '/my-results',
        name: 'my_results_page',
        meta: {
          isGuest: false,
        },
        component: () => import('@/views/programs/MyResults.vue'),
      },
    ],
  },
  {
    // the 404 route, when none of the above matches
    path: '/404',
    name: '404',
    component: () => import('@/views/authentication/Error404.vue'),
  },
  {
    path: '/auth_403',
    name: 'auth_403',
    component: () => import('@/views/authentication/Error403_login.vue'),
  },
  {
    path: '/500',
    name: '500',
    component: () => import('@/views/authentication/Error500.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404',
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((route) => {
  // reset config to initial state
  // store.commit(Mutations.RESET_LAYOUT_CONFIG);
  //
  // store.dispatch(Actions.VERIFY_AUTH);
  if (!route.meta.isGuest) {
    // store.dispatch("moduleAuth/verify")
    //     .then()
    //     .catch((response) => {
    //         helper.handleResponse(response, i18n.global.t, router, store, {});
    //     });
  }
  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

export default router;
